export const SupergatorActionTypes = {
  SSO_EMIT_REQUEST: 'SUPERGATOR_SSO_EMIT_REQUEST',
  SSO_EMIT_SUCCESS: 'SUPERGATOR_SSO_EMIT_SUCCESS',
  SSO_EMIT_FAILURE: 'SUPERGATOR_SSO_EMIT_FAILURE',
};
